import React from "react";
import { FaExclamationCircle } from "react-icons/fa";
import { useAuth } from "../../../_helper/Auth/AuthProvider";

const FileUploadCard = ({
  files,
  file,
  ticketId,
  index,
  theme,
  progress,
  remainingTime,
  errorMsg,
  handleRemoveFile,
  isOverwriteShown,
  loadingOverwrite,
  handleDeleteFile,
  formatFileSize,
  formatTime,
  getFileIcon,
  uploadStatus,
  setUploadStatus,
}) => {
  const { authToken } = useAuth();
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const backendPort = process.env.REACT_APP_BACKEND_PORT;

  let apiUrl = `${backendUrl}`;

  if (backendPort) {
    apiUrl += `:${backendPort}`;
  }
  const file_extension = file?.name?.split(".").pop()?.toLowerCase();

  // const [isOverwriteShown, setIsOverwriteShown] = useState(true);
  // const [loadingOverwrite, setLoadingOverwrite] = useState(false);

  // const handleDeleteFile = async (fileToRetry, indexToRetry) => {
  //   setLoadingOverwrite(true); // Show loading state

  //   const getKeyByName = (fileName) => {
  //     const file = files.find((f) => f.name === fileName);
  //     return file ? file.key : null;
  //   };
  //   const key = getKeyByName(`${ticketId}_${fileToRetry.name.replace(/\s+/g, "_")}`);

  //   try {
  //     if (authToken) {
  //       const response = await axios.post(`${apiUrl}/api/delete-file`, {
  //         token: authToken,
  //         params: {
  //           workspace: "INFLOW",
  //           path: `${ticketId}_${fileToRetry.name.replace(/\s+/g, "_")}`,
  //         },
  //       });

  //       if (response.status === 200) {
  //         setUploadStatus(""); // Optional reset
  //         setIsOverwriteShown(false); // Hide error & button
  //       } else {
  //         toast.error("Something went wrong.", { autoClose: 1000 });
  //       }
  //     }
  //   } catch (err) {
  //     toast.error("Something went wrong.", { autoClose: 1000 });
  //   } finally {
  //     setLoadingOverwrite(false); // Remove loading state regardless of outcome
  //   }

  //   try {
  //     if (authToken) {
  //       const response = await axios.post(`${apiUrl}/api/date-imap-remove`, {
  //         token: authToken,
  //         params: {
  //           key: key,
  //           uuid: ticketId,
  //           workspace: "INFLOW",
  //         },
  //       });

  //       if (response.status === 200) {
  //         setUploadStatus(""); // Optional reset
  //         setIsOverwriteShown(false); // Hide error & button
  //       } else {
  //         toast.error("Something went wrong.", { autoClose: 1000 });
  //       }
  //     }
  //   } catch (err) {
  //     toast.error("Something went wrong.", { autoClose: 1000 });
  //   } finally {
  //     setLoadingOverwrite(false); // Remove loading state regardless of outcome
  //   }

  // };

  return (
    <div
      key={index}
      style={{
        position: "relative",
        display: "flex",
        alignItems: "flex-start",
        background: theme === "dark-only" ? "#1d1e26" : "#fff",
        boxShadow:
          theme === "dark-only"
            ? "0 2px 6px rgba(255,255,255,0.1)"
            : "0 2px 6px rgba(0,0,0,0.15)",
        borderRadius: 8,
        padding: 10,
        marginBottom: 10,
        color: theme === "dark-only" ? "#f1f1f1" : "#000",
      }}
    >
      {/* Close Button */}
      <button
        onClick={(e) => handleRemoveFile(e, index)}
        style={{
          position: "absolute",
          top: "5px",
          right: "5px",
          transform: "translate(50%, -50%)",
          background: "#002878",
          border: "1px solid #ccc",
          borderRadius: "50%",
          color: "#ffffff",
          fontSize: "14px",
          width: "24px",
          height: "24px",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        title="Remove file"
      >
        <i className="fa fa-close text-sm"></i>
      </button>

      {/* Image Preview or File Icon */}
      {file_extension?.match(/png|jpg|jpeg/i) ||
      file?.type?.startsWith("image/") ? (
        <img
          src={URL.createObjectURL(file)}
          alt={file.name}
          style={{
            width: 48,
            height: 48,
            borderRadius: 6,
            objectFit: "cover",
            marginRight: 12,
            flexShrink: 0,
            border: `1px solid ${theme === "dark-only" ? "#444" : "#ddd"}`,
          }}
        />
      ) : (
        <div
          className="flex flex-col justify-center items-center w-full h-full bg-gray-100 text-gray-500"
          style={{ width: 48, height: 48, marginRight: 12 }}
        >
          <div className="w-full flex justify-center">
            {getFileIcon(file_extension)}
          </div>
        </div>
      )}

      {/* File Details */}
      <div style={{ flex: 1 }}>
        <p
          style={{
            wordBreak: "break-word", // Ensures long words break
            overflowWrap: "break-word", // Ensures wrapping at appropriate points
            whiteSpace: "normal", // Allows multi-line wrapping
            maxWidth: "100%", // Prevents it from exceeding container width
            display: "block", // Ensures proper wrapping behavior
          }}
        >
          {file.name}
        </p>

        <div style={{marginTop: -18, marginBottom: -12}}>
          <p
            className="text-xs text-gray-500"
            style={{
              color: theme === "dark-only" ? "#aaa" : "gray",
            }}
          >
            {formatFileSize(file.size)}
          </p>
        </div>

        {/* Progress Bar */}
        <div
          style={{
            height: "8px",
            background: theme === "dark-only" ? "#333" : "#eee",
            borderRadius: "4px",
            marginTop: "4px",
            overflow: "hidden",
            display:
              uploadStatus === "Some files failed to upload."
                ? "none"
                : "block",
          }}
        >
          <div
            style={{
              width: `${Math.max(0, Math.min(progress, 100))}%`,
              height: "100%",
              background: progress === -1 ? "#e63946" : "#4caf50",
              borderRadius: "4px",
              transition: "width 0.4s ease-in-out",
            }}
          ></div>
        </div>

        {/* Upload Status */}
        <small
          style={{
            color: theme === "dark-only" ? "#ccc" : "#555",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginTop: 8,
              flexWrap: "wrap",
              gap: 8,
            }}
          >
            {progress === -1 && isOverwriteShown ? (
              <>
                <div
                  style={{
                    display: "flex",
                    alignItems: "flex-start", // Aligns icon to top when text wraps
                    flex: 1,
                    minWidth: 0,
                    gap: 6, // Adds space between icon and text
                  }}
                >
                  <FaExclamationCircle
                    style={{ color: "#e63946", flexShrink: 0 }}
                  />
                  <span
                    style={{
                      wordBreak: "break-word", // Ensures breaking long words
                      overflowWrap: "break-word", // Ensures wrapping at appropriate points
                      whiteSpace: "normal", // Allows text to wrap
                      flex: 1, // Ensures it takes available space
                    }}
                  >
                    {`Failed - ${errorMsg || "Unknown error"}`}
                  </span>
                </div>

                {/* <button
                  onClick={(event) => {
                    event.stopPropagation();
                    event.preventDefault();
                    handleDeleteFile(file, '');
                  }}
                  disabled={loadingOverwrite}
                  style={{
                    padding: "4px 10px",
                    fontSize: "12px",
                    background: loadingOverwrite ? "#d97706" : "#f59e0b",
                    color: "#fff",
                    border: "none",
                    borderRadius: "4px",
                    cursor: loadingOverwrite ? "not-allowed" : "pointer",
                    opacity: loadingOverwrite ? 0.7 : 1,
                  }}
                >
                  {loadingOverwrite ? "Overwriting..." : "Overwrite"}
                </button> */}
              </>
            ) : (
              <>
                <span>{`${Math.max(progress, 0)}%`}</span>
                {progress >= 0 && progress < 100 && remainingTime != null && (
                  <>
                    <span style={{ margin: "0 6px" }}>|</span>
                    <span>⏳ {formatTime(remainingTime)}</span>
                  </>
                )}
              </>
            )}
          </div>
        </small>
      </div>
    </div>
  );
};

export default FileUploadCard;
